import {LatestPressReleasesRoot} from './root';
import {LatestPressReleasesTitle} from './title';
import {LatestPressReleasesCarousel} from './carousel';

export const latestPressReleases = {
  root: LatestPressReleasesRoot,
  title: LatestPressReleasesTitle,
  carousel: LatestPressReleasesCarousel,
};
